







































import DataTableDeCrudPaginado from '@/components/ui/DataTableDeCrudPaginado.vue';
import DialogoDeEdicaoDeCanalDeVendas from '@/components/venda/DialogoDeEdicaoDeCanalDeVendas.vue';
import ImagemDeTabela from '@/components/ui/ImagemDeTabela.vue';
import { CanaldeVendas, Page, Pageable } from '@/models';
import { montarOperacaoDeRecurso } from '@/shareds/permissoes-shareds';
import { montarUrlAssinadaDeCanalDeVendas } from '@/shareds/s3/urlAssinadaDeCanalDeVendas';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import { FindCanalDeVendasUseCase } from '@/usecases';
import { CancelToken } from 'axios';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import Almodelogo from '@/assets/almode_256x181.png'

const CANAL_ALMODE = '00000000-0000-0000-0000-000000000000';

@Component({
	components: {
		DataTableDeCrudPaginado,
		DialogoDeEdicaoDeCanalDeVendas,
		ImagemDeTabela,
	},
})
export default class TelaDeCadastroDeCanalDeVendas extends Vue {
	@Ref() dataTablePaginado!: DataTableDeCrudPaginado
	@Ref() dialogoDeEdicaoDeCanalDeVendas!: DialogoDeEdicaoDeCanalDeVendas
	findCanalDeVendasUseCase = new FindCanalDeVendasUseCase()
	busca = ''
	canaisDeVendas: CanaldeVendas[] = []
	carregando = false
	editando = false
	headers = [
		{ text: 'Canal de Vendas', value: 'nome', sortable: false },
		{ text: 'Imagem', value: 'imageURL', sortable: false },
	]

	get podeAlterarCanalDeVendas() {
		return UserLoginStore.temAutorizacao(montarOperacaoDeRecurso('alterar', 'canais-de-vendas'))
	}

	get podeCriarCanalDeVendas() {
		return UserLoginStore.temAutorizacao(montarOperacaoDeRecurso('criar', 'canais-de-vendas'))
	}

	get temAcessoIrrestrito() {
		return UserLoginStore.permiteRegraDeNegocio('acesso-irrestrito')
	}

	abrirDialogoDeEditarCanalDeVendas(indice: number) {
		const canalDeVendas = this.canaisDeVendas[indice]
		if(canalDeVendas.id === CANAL_ALMODE){
			AlertModule.setInfo('Não é possível editar o canal de vendas Almode.')
			return
		}
		this.editando = true
		this.dialogoDeEdicaoDeCanalDeVendas.mostrar(canalDeVendas)
	}

	abrirDialogoDeCriarBandeira() {
		try {
			this.editando = false
			const canalDeVendas = { id: null, nome: '', imageURL: '' }
			this.dialogoDeEdicaoDeCanalDeVendas.mostrar(canalDeVendas)
		} catch (error) {
			AlertModule.setError(error)
		}
	}

	async buscarPagina(paginavel: Pageable, parametros: {
		busca?: string
	}, cancelToken: CancelToken): Promise<Page<CanaldeVendas>> {
		const pagina = await this.findCanalDeVendasUseCase.findAll({
			...parametros,
			...paginavel,
		}, {
			cancelToken,
		})
		this.canaisDeVendas = pagina.content
		this.canaisDeVendas.forEach(canal => {
			if (canal.id === CANAL_ALMODE) {
				canal.imageURL = Almodelogo
			}
		})
		return pagina
	}

	async salvarCanalDeVendas(canalDeVendasSalvo: CanaldeVendas) {
		canalDeVendasSalvo = await montarUrlAssinadaDeCanalDeVendas(canalDeVendasSalvo)
		const indice = this.canaisDeVendas.findIndex(canalDeVendas => canalDeVendas.id === canalDeVendasSalvo.id)

		if (indice >= 0) {
			this.canaisDeVendas.splice(indice, 1, canalDeVendasSalvo)
		} else {
			this.canaisDeVendas.push(canalDeVendasSalvo)
		}
	}

	@Watch('busca')
	novaBusca() {
		this.dataTablePaginado.reiniciar({
			busca: this.busca,
		})
	}
	@Watch('carregando')
	onChangeMostrar() {
		this.dataTablePaginado.reiniciar({
			busca: this.busca,
		})
	}
}
